<template>
  <div>
    <MovieBlockedContainer
      v-if="content.component === 'movie'"
      :data="data"
      :content="content"
      :model="model"
      :imgStyle="imgStyle"
      :cssVars="cssVars"
      :link="link"
    />
    <PictureBlockedContainer
      v-else-if="content.component === 'picture'"
      :data="data"
      :content="content"
      :model="model"
      :imgStyle="imgStyle"
      :cssVars="cssVars"
      :link="link"
    />
    <div v-else>
      {{$t('video_watch.not_available')}}
    </div>
  </div>

</template>

<script setup lang="ts">
import { PostData, PostContent } from '@/types/Post';

interface _Props {
  data: PostData;
  content: PostContent;
  model?: any;
};

const { data, model, content } = withDefaults(defineProps<_Props>(), {
  model: {},
});

const imgStyle = computed(() => {
  let image = content.public_thumbnail_image_path['small'];
  return {
    backgroundImage: `url('${image}')`
  };
});

const cssVars = computed(() => {
  const fc = data.front_container;

  const url = (fc === 'normal' || fc === 'tokens')
  ? content.public_thumbnail_image_path['small']
  : `/img/posts/${fc}.png`;

  return {
    '--background': `url('${url}')`,
  }
});

const link = computed(() => {
  switch (data.front_container) {
    case 'free':
      return {name: 'signup.user'}
    case 'premium':
      return {name: 'purchase.subscription', query: {webstar: model.username}}
    case 'normal':
      return {name: 'purchase.subscription', query: {webstar: model.username}}
    default:
      return {name: 'signup.user'}
  }
});
</script>